export enum AssessmentTypeEnum {
    SelfReportedInformation = 1,
    PastPresentHistory = 2,
    PastSurgicalHistory = 3,
    ReviewSystems = 4,
    PhysicalExam = 5,
    Functional = 6,
    Physical = 7,
    Social = 8,
    Allergies = 9,
    Medication = 10,
    GeneralEncounter = 11,
    ProcedureSignOff = 12,
    PatientHealthQuestionnaire = 13,
    UrinalysisReport = 14,
    BehaviourHealthInterview = 15,
    PatientScreeningSurvey = 16,
    ACEAssessment = 17,
    HgbA1CAssessment = 18,
    DiabetesFootAssessment = 19,
    SdohAssessment = 20,
    BudgetForm = 21,
    LipidAssessment = 22,
    TobaccoAndDrug = 23,
    SexualHealth = 24,
    ADL = 25,
    FallRisk = 26,
    VisionAndHearing = 27,
    PreventativeHealthAdvice = 28,
    AdvancedDirective = 29,
    AdditionalCHPCriteria = 30,
    ScreeningFuhFum = 31,
    HamiltonAnxietyScale = 32,
    CulturalConsiderations = 33,
    DevelopmentalHistory = 34,
    LegalHistory = 35,
    EatingDisorder = 36,
    CurrentNeeds = 37,
    MentalHealthTreatmentHistory = 38,
    AbuseHistory = 39,
    Consent = 40,
    VitalSigns = 41,
    Counseling = 42,
    MiniMentalStatusExam = 43,
    SubjectiveAssessment = 44,
    GlobalAssessmentFunctioningScale = 45,
    OtherFactorsRisks = 46,
    ProgressNotes = 47,
    SuicidalHomicidalIdeation = 48,
    PhysicalHealth = 49,
    CarePlans = 50,
    Demographics = 51,
    PCPSpecialistsPharmacy = 52,
    CareCircle = 53,
    PRAPARE_SDoh = 54,
    TransitionalCare = 55,
    AssignEducation = 56,
    RemoteMonitoring = 57,
    RequestsReferrals = 58,
    Interventions = 59,
    MedicationReconciliation = 60,
    Tablets = 61,
    HRAEducation = 62,
    FollowUp = 63,
    SetAppointmentInfo = 64,
    SafetyPlan = 65,
}
